module.exports = __webpack_public_path__ + "static/media/plan-vs-actual.1e4795d2.svg";